import { FormValues } from "@/interfaces/FormValues";
import { GetterTree } from "vuex";
import { RootState } from "./state";
import { PAGE_NAMES } from "@/constants/form-page-names";
import { GENERAL_FIELD_NAMES } from "@/constants/form-field-names";

export const getters: GetterTree<RootState, RootState> = {
  allFormValues(state: RootState): Record<string, FormValues> {
    return state.allFormValues;
  },

  myJLSToken(state: RootState): string {
    return state.myJLSToken;
  },

  userEmail(state: RootState): string {
    if (
      state.allFormValues[PAGE_NAMES.general] &&
      state.allFormValues[PAGE_NAMES.general][GENERAL_FIELD_NAMES.mail]
    ) {
      return state.allFormValues[PAGE_NAMES.general][
        GENERAL_FIELD_NAMES.mail
      ] as string;
    }
    return "";
  },

  userName(state: RootState): string {
    return state.userName;
  },

  bankName(state: RootState): string {
    return state.bankName;
  },
};
